//==============================
// Home Work Items
//==============================

// var imageGallery = $('.home-work-items').masonry({
//   itemSelector: '.home-work-item',
//   percentPosition: true,
//   gutter: 10
// });

// imageGallery.imagesLoaded().progress( function() {
//   imageGallery.masonry('layout');
//   setTimeout(function() {
//     $('.home-work-item').addClass('show');
//   }, 500);
// });


var workDesign = $('.work-design').masonry({
  itemSelector: '.work-design-item',
  percentPosition: true,
  gutter: 0
});

workDesign.imagesLoaded().progress( function() {
  workDesign.masonry('layout');
  setTimeout(function() {
    $('.work-design-item').addClass('show');
  }, 500);
});
